/**
 * Junta as mensagens ANTIGAS que acabaram de chegar com as que já estão na
 * tela, sem repetir nenhuma e sem bagunçar a ordem.
 *
 * ## Por que isto não é um `[...antigas, ...atuais]`
 *
 * Duas coisas alimentam a mesma lista, e elas se cruzam:
 *
 * 1. a **paginação** (`GET /messages/{id}?page=N`), que é por OFFSET sobre uma
 *    ordenação decrescente. Se uma mensagem nova chegar entre pedir a página 1
 *    e pedir a página 2, tudo desce uma posição e o primeiro item da página 2 é
 *    o último item da página 1 -- **repetido**. (O contrário, pular uma
 *    mensagem, só aconteceria se alguma fosse APAGADA, e nada apaga mensagem.)
 * 2. o **socket**, que em quase todo evento devolve a CONVERSA INTEIRA (ver
 *    `utils/mesmaListaDeMensagens`). Um recibo de leitura chegando no meio do
 *    carregamento substitui a lista por tudo -- e aí as "antigas" que estavam
 *    vindo já estão lá.
 *
 * Casar por `id` resolve os dois casos de uma vez. A mensagem mais NOVA de cada
 * id vence: ela carrega o `read_at` e o `meta.ack` atualizados, que são os
 * campos que desenham os tiques.
 *
 * Mensagem sem `id` é mantida como está -- não existe hoje (tudo vem do
 * servidor já gravado), mas descartá-la silenciosamente seria o tipo de perda
 * que ninguém percebe.
 */
export const mensagensMescladas = (atuais, antigas) => {
    const lista = (entrada) => (Array.isArray(entrada) ? entrada : []);

    const semId = [];
    const porId = new Map();

    // As ATUAIS entram depois para vencer o empate: elas são o estado mais
    // recente de cada mensagem.
    [...lista(antigas), ...lista(atuais)].forEach((mensagem) => {
        if (!mensagem) return;

        if (mensagem.id === undefined || mensagem.id === null) {
            semId.push(mensagem);
            return;
        }

        porId.set(String(mensagem.id), mensagem);
    });

    return [...porId.values(), ...semId].sort((a, b) => {
        const diferenca = new Date(a.created_at) - new Date(b.created_at);
        if (diferenca) return diferenca;

        // Mesmo instante (acontece com mensagens gravadas na mesma transação):
        // o id decide, para a ordem não dançar entre renders.
        return Number(a.id || 0) - Number(b.id || 0);
    });
};
